import { Skeleton } from "@heroui/skeleton";

export const QuestCardSkeleton = () => {
  return (
    <div className="relative bg-neutral-800/90 rounded-2xl p-6 h-full flex flex-col">
      {/* Icon at top */}
      <div className="flex items-center mb-6">
        <Skeleton className="rounded-full w-16 h-16" />
      </div>

      {/* Title */}
      <div className="flex-1 mb-6 space-y-2">
        <Skeleton className="rounded-lg w-full h-5" />
        <Skeleton className="rounded-lg w-3/4 h-5" />
      </div>

      {/* Footer with Points and Arrow */}
      <div className="flex items-center justify-between w-full">
        <Skeleton className="rounded-lg w-20 h-6" />
        <Skeleton className="rounded-lg w-5 h-5" />
      </div>
    </div>
  );
};
